import React from "react";
import { Paper, Typography, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import StyledButton from "../../Landing/components/StyledButton";

const useStyles = makeStyles({
  paper: {
    color: "white",
    padding: "32px",
    borderRadius: 16,
    position: "relative",
    "&.blue": {
      background: "#1440cc"
    },
    "&.cyan": {
      background: "#2fbfbd"
    },
    "& svg": {
      position: "absolute",
      left: 20,
      bottom: -28,
      transform: "rotate(-25deg)"
    }
  },
  title: {}
});

export default function ChooseCard({ title, button, color, icon, btnId }) {
  const classes = useStyles();
  return (
    <Paper className={clsx(classes.paper, color)}>
      <Typography variant="h5" className={classes.title}>
        {title}
      </Typography>
      <br />
      <StyledButton id={btnId}>{button}</StyledButton>
      {icon}
    </Paper>
  );
}
